import { common } from '@qwyk/models';

export const TRANSPORT_MODE_OCEAN = common.TransportMode.OCEAN;
export const TRANSPORT_MODE_AIR = common.TransportMode.AIR;
export const TRANSPORT_MODE_RAIL = common.TransportMode.RAIL;
export const TRANSPORT_MODE_TRUCK = common.TransportMode.TRUCK;

export const TRANSPORT_MODES = [
    { key: TRANSPORT_MODE_OCEAN, value: 'Ocean' },
    { key: TRANSPORT_MODE_AIR, value: 'Air' },
    { key: TRANSPORT_MODE_RAIL, value: 'Rail' },
    { key: TRANSPORT_MODE_TRUCK, value: 'Truck' },
    { key: 'UNDETER', value: 'Undetermined' }
];
export const TRANSPORT_MODE_DICT = TRANSPORT_MODES.reduce((prev, next) => {
    prev[next.key] = next.value;
    return prev;
}, {} as Record<string, string>);

export const CARRIER_SCAC_OTHER = common.CARRIER_SCAC_OTHER;
export const RATE_SOURCE_CATAPULT = common.RATE_SOURCE_CATAPULT;
